// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".p-autocomplete.p-inputwrapper[data-v-b1a588ec]{background-color:transparent;border:none}.pi.pi-search[data-v-b1a588ec]{cursor:pointer}", ""]);
// Exports
module.exports = exports;
